/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import { Link, useParams } from "react-router-dom";
import "./PowerBi.css";
import { POWER_BI_EMBED_URL } from "src/url/Url";
import api from "src/redux/actions/apis";
import { NotificationPopup } from "src/utils/Notifications";
import SpinerLoader from "src/utils/SpinerLoader";

import Header from "../../Containers/Header";
import { languageJson } from "../../StringVariable";

import portimg1 from "../../assets/AggregatedDwell/1.jpg";
import portimg2 from "../../assets/AggregatedDwell/3.jpg";
import portimg3 from "../../assets/AggregatedDwell/2.jpg";
const PowerBiReportDwellData = () => {
  const [embedConfig, setEmbedConfig] = React.useState(null);
  const [loader, setLoader] = useState(true);
  const { id } = useParams(); // Extract "id" from URL
  React.useEffect(() => {
    fetchEmbedToken(id);
  }, [id]);

  const fetchEmbedToken = async (id) => {
    try {
      setLoader(true);
      await api.get(POWER_BI_EMBED_URL(id)).then((res) => {
        const { data, customcode, message } = res.data;
        if (customcode === 200) {
          setEmbedConfig({
            reportId: data.id,
            embedUrl: data.embedUrl,
            token: data.embedToken,
          });
        } else {
          NotificationPopup(customcode, message);
        }
        setLoader(false);
      });
    } catch (err) {
      console.log(err);
    }
  };
  document.addEventListener("fullscreenchange", () => {
    if (!document.fullscreenElement) {
      console.log("Exited full screen");
    }
  });
  return (
    <div>
      <Header />
      {/* <div className="headerBannerMainDiv">
      <img className="vessel_img" src={railcrossingbanner} alt="vessel" />
    </div> */}
      <div className="image-row-banner">
        <img className="banner_img" src={portimg1} alt="" />
        <img className="banner_img" src={portimg3} alt="" />
        <img className="banner_img" src={portimg2} alt="" />
      </div>
      <div className="vo-bg">
        <div className="container-fluid row py-4 ">
          <div>
            <Link to="/">
              {" "}
              <span className="vo-menu pe-2">
                {languageJson.home_txt}{" "}
              </span>{" "}
            </Link>
            <span className="text-dark ps-2">
              {" "}
              / &nbsp; {languageJson.aggregate_dwell_text}
            </span>
          </div>
        </div>
      </div>

      {/* ------------------------------------------------------ */}
      <div
        className="railCrossinglRoutesMainDiv"
        style={{ marginTop: "-100px" }}
      >
        <section className="railcrossing-head container py-5">
          <div className="row container-fluid py-5 tabVesselDiv">
            <div className="d-flex justify-content-center">
              <div className="truckTurnTimeMainDiv historicalTTTMainDiv">
                <div className="container">
                  <div className="titleDescpDiv">
                    <h2>{languageJson.aggregate_dwell_text}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {embedConfig?.reportId &&
            embedConfig?.embedUrl &&
            embedConfig?.token && (
              <div className="zoom-button-container">
                <button
                  className="zoom-button"
                  onClick={() => {
                    if (window.report) {
                      window.report.fullscreen();
                    }
                  }}
                >
                  🖥️ {languageJson.full_Screen_view}
                </button>
              </div>
            )}
          {loader ? (
            <SpinerLoader />
          ) : (
            embedConfig?.reportId &&
            embedConfig?.embedUrl &&
            embedConfig?.token && (
              <PowerBIEmbed
                embedConfig={{
                  type: "report", // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                  id: embedConfig.reportId,
                  embedUrl: embedConfig.embedUrl,
                  accessToken: embedConfig.token,
                  tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
                  settings: {
                    panes: {
                      filters: {
                        expanded: false,
                        visible: false,
                      },
                    },
                    background: models.BackgroundType.Transparent,
                    navContentPaneEnabled: false,
                  },
                }}
                eventHandlers={
                  new Map([
                    [
                      "loaded",
                      function () {
                        setLoader(false);
                        console.log("Report loaded");
                      },
                    ],
                    [
                      "rendered",
                      function () {
                        console.log("Report rendered");
                      },
                    ],
                    [
                      "error",
                      function (event) {
                        console.log(event.detail);
                      },
                    ],
                    ["visualClicked", () => console.log("visual clicked")],
                    ["pageChanged", (event) => console.log(event)],
                  ])
                }
                cssClassName={"reportClassView"}
                getEmbeddedComponent={(embeddedReport) => {
                  window.report = embeddedReport;
                }}
              />
            )
          )}

          {embedConfig?.reportId &&
            embedConfig?.embedUrl &&
            embedConfig?.token && (
              <div style={{ margin: "50px" }}>
                <p>
                  <strong>Q:</strong>What is dwell time and why does it matter?
                </p>
                <p>
                  <strong>A:</strong> Dwell time refers to the amount of time a
                  container remains at the terminal after being discharged from
                  a vessel. High dwell times can indicate congestion,
                  inefficiencies in pickup scheduling, or issues in the
                  downstream supply chain. Monitoring this metric helps
                  terminals and stakeholders with performance visibility,
                  identify trends, optimize yard operations, and improve
                  container flow.
                </p>

               
             
                <p>
                  <strong>Definitions:</strong>
                </p>
                <p>
                  <strong></strong>
                  
                   <strong>• Dwell Time – </strong>These containers have
                  been gated out of the terminal, and their dwell time is
                  calculated from vessel unload to gate-out. This provides a
                  final, complete measure of how long they stayed on terminal
                  property.
                  <br /> <strong>• Export Dwell – </strong>Shows dwell time for
                  containers that are being sent out via a vessel, including
                  those waiting to be loaded onto a ship.
                  <br /> <strong>• Import Dwell – </strong>Shows dwell time for
                  containers that were brought into the terminal from a vessel
                  and are waiting to be picked up or have already been picked
                  up.
                </p>
              </div>
            )}
        </section>
        {/* ----------------------------------------------------------------------------------------- */}
      </div>
      {/* ----------------------------------------------------------------------------------------- */}
    </div>
  );
};

export default PowerBiReportDwellData;
